var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-restricted-imports */
import { showGroupNamesDialog } from '../../../../../../ui/features/alerts/components/AlertView/components/GroupNamesDialog';
import { DataTable, TextCell } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar, useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { MenuButton } from '@juvare/common-web-ui/MenuButton';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useGroupStorage } from '@juvare/contact-management/AppClients';
import { showGroupDetailsDialog, showGroupsDialog } from '@juvare/contact-management/ui/features/groups';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { addAlertRespondersToFollowUpBulkActionType, addAlertRespondersToGroupBulkActionType, searchAlertRespondersPageSize, } from '../../../../../../backend/features/alerts/bulk-actions';
import { followUpAccountMapEntityName } from '../../../../../../backend/features/alerts/entities/FollowUpAccountMap';
import { useAlertConfig, useAlertUiTranslation } from '../../../../../hooks';
import { useAlertsUrl } from '../../../../../hooks/useAlertsUrl';
import { showNotificationDialog } from '../../AlertDialog';
import { mapToAlertWizardFormData } from '../../AlertDialog/Utils';
import { CollapsableSection } from './CollapsableSection';
export const AlertRespondersTable = ({ data, result }) => {
    var _a, _b;
    const { t } = useAlertUiTranslation();
    const alertsSentUrl = useAlertsUrl('sent');
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const alertConfig = useAlertConfig();
    const groupStorageClient = useGroupStorage();
    const { dataTableProps, filtersBarProps, appliedFilterData } = result;
    const filterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({ dataPath: 'searchText', label: t('common.search') });
        builder.quickFilterSelect({
            dataPath: 'status',
            label: t('common.deliveryStatus'),
            values: [
                { value: 'contacted', label: t('enum.deliveryStatus.contacted') },
                { value: 'unreachable', label: t('enum.deliveryStatus.unreachable') },
                { value: 'notYetContacted', label: t('enum.deliveryStatus.notYetContacted') },
                { value: 'canceled', label: t('enum.deliveryStatus.canceled') },
            ],
            sx: { maxWidth: 400 },
            widget: 'form.radio',
        });
        if (data.responseOptions.length > 0) {
            builder.quickFilterMultiSelect({
                dataPath: 'responses',
                label: t('common.responseStatus'),
                values: [
                    ...data.responseOptions.map((option) => ({ value: option.optionId, label: option.text })),
                    { value: '-', label: t('common.noResponse') },
                ],
                sx: { maxWidth: 400 },
                widget: 'form.checkboxList',
            });
        }
        builder.quickFilterSelect({
            dataPath: 'type',
            label: t('common.type'),
            values: [
                {
                    value: 'individual',
                    label: t('enum.recipientsType.internal'),
                },
                {
                    value: 'external',
                    label: t('enum.recipientsType.external'),
                },
                { value: 'cc', label: t('enum.recipientsType.cc') },
            ],
            sx: { maxWidth: 400 },
            widget: 'form.radio',
        });
    }, [t, data.responseOptions]);
    const totalRowCount = data.responderCounts.totalCount;
    const selectedRowIds = (_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [];
    const filteredRowCount = (_b = dataTableProps.filteredRowCount) !== null && _b !== void 0 ? _b : 0;
    const launchAddAlertRespondersToGroupBulkAction = (groupId, all) => {
        const responderCount = all ? totalRowCount : selectedRowIds.length > 0 ? selectedRowIds.length : filteredRowCount;
        if (responderCount > 0) {
            launchBulkAction({
                type: addAlertRespondersToGroupBulkActionType,
                title: t('common.addingAlertRespondersToGroup'),
                runSync: responderCount <= searchAlertRespondersPageSize,
                params: {
                    groupId: groupId,
                    alertId: data.id,
                    responderCount: responderCount,
                    request: all
                        ? undefined
                        : selectedRowIds.length === 0
                            ? {
                                status: appliedFilterData.status,
                                responses: appliedFilterData.responses,
                                searchText: appliedFilterData.searchText,
                                type: appliedFilterData.type,
                            }
                            : undefined,
                    externalIds: all ? undefined : selectedRowIds.length === 0 ? undefined : selectedRowIds,
                },
                onClose: () => {
                    // nothing to do?
                },
            });
        }
    };
    const handleSendFollowUp = (all) => {
        const additionalData = data.additionalData
            ? Object.fromEntries(Object.entries(data.additionalData).filter(([key]) => key !== 'customAlertData'))
            : undefined;
        const responderCount = all ? totalRowCount : selectedRowIds.length > 0 ? selectedRowIds.length : filteredRowCount;
        if (responderCount > 0) {
            launchBulkAction({
                type: addAlertRespondersToFollowUpBulkActionType,
                title: t('common.addingAlertRespondersToFollowUp'),
                runSync: responderCount <= searchAlertRespondersPageSize,
                autoCloseWhenFinished: true,
                params: {
                    alertId: data.id,
                    responderCount: responderCount,
                    request: all
                        ? undefined
                        : selectedRowIds.length === 0
                            ? {
                                status: appliedFilterData.status,
                                responses: appliedFilterData.responses,
                                searchText: appliedFilterData.searchText,
                                type: appliedFilterData.type,
                            }
                            : undefined,
                    externalIds: all ? undefined : selectedRowIds.length === 0 ? undefined : selectedRowIds,
                },
                onClose: ({ status, result }) => {
                    var _a;
                    if (status === 'finished' && result) {
                        const alertWizardFormData = mapToAlertWizardFormData(Object.assign(Object.assign({}, data), { additionalData: additionalData }), alertConfig);
                        showNotificationDialog({
                            mode: 'notification',
                            reviewFormHeader: t('pages.newFromTemplate.reviewAndSend'),
                            wizardHeader: t('pages.newFromTemplate.createNotification'),
                            dialogStep: 'wizard',
                            partialAlert: Object.assign(Object.assign({}, alertWizardFormData), { id: undefined, subject: t('common.followUpSubjectPrefix') + ' ' + alertWizardFormData.subject, htmlMessage: alertWizardFormData.htmlMessage
                                    ? t('common.followUpHtmlMessagePrefix') + alertWizardFormData.htmlMessage
                                    : alertWizardFormData.htmlMessage, sendDateTime: undefined, sendType: 'immediately', emailCc: result.ccEmails, voiceRecordings: undefined, permissions: undefined, recipients: {
                                    internal: {
                                        includeNonMembers: true,
                                        accounts: [],
                                        accountsFilter: [
                                            {
                                                op: 'in',
                                                idSubFilter: {
                                                    column: 'accountId',
                                                    entity: followUpAccountMapEntityName,
                                                    filter: [{ column: 'followUpId', op: '=', value: result.followUpId }],
                                                },
                                            },
                                        ],
                                        groups: [],
                                        organizations: [],
                                    },
                                    external: result.importId
                                        ? {
                                            importId: result.importId,
                                            rowCount: (_a = result.externalRecipientsRowCount) !== null && _a !== void 0 ? _a : 0,
                                        }
                                        : undefined,
                                }, followUp: {
                                    id: result.followUpId,
                                    previousAlertId: data.id,
                                } }),
                            onSubmitSuccess: (_data, onClose) => {
                                showAlertSnackbar({
                                    message: t('pages.edit.snackbar.notification.sent'),
                                    type: 'success',
                                    autoHideDuration: 1000,
                                });
                                onClose();
                                navigationContext.navigate(() => navigate(alertsSentUrl));
                            },
                        });
                    }
                },
            });
        }
    };
    const handleAddToNewGroup = (all) => {
        showGroupDetailsDialog({
            initialData: {
                filterBased: false,
                visibility: 'private',
                criteria: { filters: [] },
            },
            fullWidth: true,
            maxWidth: 'sm',
            title: t('common.newGroupAlertResponders'),
            onSubmit: (groupData) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const { id } = yield groupStorageClient.post({ action: 'create', data: groupData });
                    launchAddAlertRespondersToGroupBulkAction(id, all);
                }
                catch (error) {
                    handleErrorDialog(error);
                }
            }),
        });
    };
    const handleAddToExistingGroup = (all) => {
        showGroupsDialog({
            excludeFilterBasedGroups: true,
            onSelect: (selectedId) => {
                launchAddAlertRespondersToGroupBulkAction(selectedId, all);
            },
        });
    };
    return (React.createElement(CollapsableSection, { title: React.createElement(React.Fragment, null,
            t('common.delivery'),
            ' ',
            React.createElement(Typography, { variant: 'subtitle2', component: 'span', color: themeColors.text.subtle },
                "(",
                dataTableProps.filteredRowCount,
                ")")), label: `${t('common.delivery')} (${dataTableProps.filteredRowCount})`, header: React.createElement(Box, { sx: { display: 'flex', justifyContent: 'flex-end', gap: 2 } },
            React.createElement(Button, { color: 'primary', variant: 'outlined', startIcon: React.createElement(SendOutlinedIcon, null), onClick: () => handleSendFollowUp(true) }, t('common.sendFollowUpAll')),
            React.createElement(MenuButton, { startIcon: React.createElement(GroupAddOutlinedIcon, null), endIcon: React.createElement(ArrowDropDownIcon, null), color: 'primary', variant: 'outlined', menuItems: [
                    { label: t('common.newGroup'), onClick: () => handleAddToNewGroup(true) },
                    { label: t('common.existingGroup'), onClick: () => handleAddToExistingGroup(true) },
                ] }, t('common.addToGroupAll'))) },
        React.createElement(DataTable, Object.assign({}, dataTableProps, { localActions: [
                {
                    icon: React.createElement(SendOutlinedIcon, null),
                    label: t('common.sendFollowUp'),
                    onClick: handleSendFollowUp,
                },
                {
                    icon: React.createElement(GroupAddOutlinedIcon, null),
                    label: t('common.addToGroup'),
                    menuItems: [
                        { label: t('common.newGroup'), onClick: handleAddToNewGroup },
                        { label: t('common.existingGroup'), onClick: handleAddToExistingGroup },
                    ],
                },
            ], columns: [
                {
                    headerLabel: t('common.recipient'),
                    cellField: 'name',
                },
                {
                    headerLabel: t('common.status'),
                    cellFunction: (row) => {
                        if (row.status) {
                            return React.createElement(TextCell, null, t(`enum.alertResponderStatus.${row.status}`));
                        }
                        else {
                            return null;
                        }
                    },
                },
                {
                    headerLabel: t(`pages.tables.details.respondersTable.type`),
                    cellFunction: (row) => {
                        if (row.type) {
                            return (React.createElement(TextCell, null, t(`pages.tables.details.respondersTable.responderType.${row.type}`)));
                        }
                        else {
                            return null;
                        }
                    },
                    tableCellSx: {
                        display: {
                            xs: 'none',
                            sm: 'table-cell',
                        },
                    },
                },
                {
                    headerLabel: t(`pages.tables.details.respondersTable.groupNames`),
                    cellFunction: (row) => {
                        if (row.groupNames.length > 1 && row.type !== 'external') {
                            return (React.createElement(Button, { variant: 'text', onClick: () => { var _a; return showGroupNamesDialog({ recipientName: (_a = row.name) !== null && _a !== void 0 ? _a : '', groupNames: row.groupNames }); } }, t(`pages.tables.details.respondersTable.associations`, { number: row.groupNames.length })));
                        }
                        else if (row.groupNames.length > 0 && row.type !== 'external') {
                            return React.createElement(TextCell, { sx: { pl: 1 } }, row.groupNames);
                        }
                        else {
                            return React.createElement(TextCell, { sx: { pl: 1 } }, "-");
                        }
                    },
                    tableCellSx: {
                        display: {
                            xs: 'none',
                            sm: 'table-cell',
                        },
                    },
                },
                {
                    headerLabel: t('common.response'),
                    cellFunction: (row) => {
                        if (row.responseOptionId) {
                            let text = row.responseOptionId;
                            const option = data.responseOptions.find((option) => option.optionId === row.responseOptionId);
                            if (option) {
                                text = option.text;
                            }
                            return React.createElement(TextCell, null, text);
                        }
                        else {
                            return null;
                        }
                    },
                    tableCellSx: {
                        display: {
                            xs: 'none',
                            sm: 'table-cell',
                        },
                    },
                },
            ], filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), localActionStatic: true, customTableSurfaceComponent: NoSurface }))));
};
const NoSurface = ({ children }) => children;
